import { createContext, useContext, useEffect, useState } from 'react'

import { CharacterContext } from './character'
import { DBContext } from './databases'

// import { defaultValue } from '../constants/entity'

import * as Calc from '../constants/formulas'

import { getFormatedClassName } from '../data/jobID'

export const SubStatsContext = createContext()

export const SubStatsProvider = ({ children }) => {
	const {
		job,
		jobASPD,
		baseLevel,
		STR,
		AGI,
		VIT,
		INT,
		DEX,
		LUK,
		// extraATK,
		bonuses,
	} = useContext(CharacterContext)
	const { inventory } = useContext(CharacterContext)
	const { jobBaseHp, jobBaseSp } = useContext(DBContext)
	//MaxHP calc.
	const [maxHP, setMaxHP] = useState(Number(1))
	//MaxSP calc.
	const [maxSP, setMaxSP] = useState(Number(1))
	//DEF
	const [Def, setDef] = useState(Number(0))
	//Soft DEF
	const [softDef, setSoftDef] = useState(Number(0))
	//MDEF
	const [Mdef, setMdef] = useState(Number(0))
	//Soft MDEF
	const [softMdef, setSoftMdef] = useState(Number(0))
	//Hit
	const [hit, setHit] = useState(Number(0))
	//Flee
	const [flee, setFlee] = useState(Number(0))
	//PerfectDodge
	const [perfectDodge, setPerfectDodge] = useState(Number(0))
	//Crit
	const [crit, setCrit] = useState(Number(0))
	//ASPD
	const [aspd, setASPD] = useState(Number(0))
	//ATK
	// const [baseDamage, setBaseDamage] = useState([0, 0, 0])
	const [baseMagicDamage, setBaseMagicDamage] = useState([0, 0, 0])
	const [statusATK, setStatusATK] = useState(Number(0))
	const [statusMATK, setStatusMATK] = useState(Number(0))
	const [baseWeaponDamage, setBaseWeaponDamage] = useState(Number(0))
	const [baseWeaponMagicDamage, setBaseWeaponMagicDamage] = useState(
		Number(0),
	)
	const [refinementBonus, setRefinementBonus] = useState(Number(0))
	//-----------------------------------------------------------------------------------------------------
	useEffect(() => {
		// console.log(
		// 	jobBaseHp.find((baseHp) => baseHp.Jobs[getFormatedClassName(job)])
		// )
		setMaxHP(
			Number(
				Calc.HP(
					job,
					jobBaseHp.find(
						(baseHp) => baseHp.Jobs[getFormatedClassName(job)],
					),
					Calc.isThird(job)
						? Math.max(baseLevel, 99)
						: Math.min(baseLevel, 99),
					VIT,
					bonuses.bMaxHP ? bonuses.bMaxHP : 0,
					bonuses.bMaxHPrate ? bonuses.bMaxHPrate : 0,
				),
			),
		)
		// }, [VIT, bMaxHP, bMaxHPrate, baseLevel, job, jobBaseHp])
	}, [VIT, bonuses, baseLevel, job, jobBaseHp])
	useEffect(() => {
		setMaxSP(
			Calc.SP(
				job,
				jobBaseSp.find(
					(baseSp) => baseSp.Jobs[getFormatedClassName(job)],
				),
				Calc.isThird(job)
					? Math.max(baseLevel, 99)
					: Math.min(baseLevel, 99),
				INT,
				bonuses.bMaxSP ? bonuses.bMaxSP : 0,
				bonuses.bMaxSPrate ? bonuses.bMaxSPrate : 0,
				// bMaxSP,
				// bMaxSPrate
			),
		)
		// }, [INT, bMaxSP, bMaxSPrate, baseLevel, job, jobBaseSp])
	}, [INT, bonuses, baseLevel, job, jobBaseSp])
	useEffect(() => {
		if (inventory['Right_Hand'].SubType !== 'Bow')
			setStatusATK(Calc.StatusATK(baseLevel, STR, DEX, LUK))
		else setStatusATK(Calc.StatusATK(baseLevel, DEX, STR, LUK))
	}, [inventory, baseLevel, DEX, STR, LUK])
	useEffect(() => {
		setStatusMATK(Calc.StatusMATK(baseLevel, INT, DEX, LUK))
	}, [baseLevel, INT, DEX, LUK])
	useEffect(() => {
		setBaseWeaponDamage(inventory['Right_Hand'].Attack)
		setBaseWeaponMagicDamage(
			inventory['Right_Hand'].MagicAttack
				? inventory['Right_Hand'].MagicAttack
				: 0,
		)
		setRefinementBonus(
			Calc.Refine(
				inventory['Right_Hand'].refine,
				inventory['Right_Hand'].WeaponLevel,
			),
		)
	}, [inventory])
	useEffect(() => {
		setBaseMagicDamage(
			Calc.getBaseMagicDamage(
				inventory['Right_Hand'],
				baseLevel,
				INT,
				DEX,
				LUK,
				bonuses.bMatk ? bonuses.bMatk : 0,
			),
		)
	}, [inventory, baseLevel, INT, DEX, LUK, bonuses])
	useEffect(() => {
		setDef(
			Calc.DEF(
				inventory['Head_Top'],
				inventory['Head_Mid'],
				inventory['Head_Low'],
				inventory['Armor'],
				inventory['Right_Hand'],
				inventory['Left_Hand'],
				inventory['Garment'],
				inventory['Shoes'],
				inventory['Right_Accessory'],
				inventory['Left_Accessory'],
				bonuses.bDef ? bonuses.bDef : 0,
				bonuses.bDefRate ? bonuses.bDefRate : 0,

				// bDef,
				// bDefRate
			),
		)
	}, [
		inventory,
		bonuses,
		// bDef,
		// bDefRate,
	])
	useEffect(() => {
		setSoftDef(
			Calc.SoftDEF(
				VIT,
				AGI,
				baseLevel,
				bonuses.bDef2 ? bonuses.bDef2 : 0,
				bonuses.bDef2Rate ? bonuses.bDef2Rate : 0,
			),
		)
	}, [VIT, AGI, baseLevel, bonuses /*bDef2, bDef2Rate*/])
	useEffect(() => {
		// setMdef(bMdef * (1 + bMdefRate / 100))
		setMdef(
			(bonuses.bMdef ? bonuses.bMdef : 0) *
				(1 + (bonuses.bMdefRate ? bonuses.bMdefRate : 0) / 100),
		)
	}, [bonuses /*bMdef, bMdefRate*/])
	useEffect(() => {
		setSoftMdef(
			Calc.SoftMDEF(
				INT,
				VIT,
				DEX,
				baseLevel,
				bonuses.bMdef2 ? bonuses.bMdef2 : 0,
				bonuses.bMdef2Rate ? bonuses.bMdef2Rate : 0,
			),
		)
	}, [INT, VIT, DEX, baseLevel, bonuses /*bMdef2, bMdef2Rate*/])
	useEffect(() => {
		setHit(
			Calc.HIT(
				baseLevel,
				DEX,
				LUK,
				bonuses.bHit ? bonuses.bHit : 0,
				bonuses.bHitRate ? bonuses.bHitRate : 0,
			),
		)
	}, [baseLevel, DEX, LUK, bonuses /*bHit, bHitRate*/])
	useEffect(() => {
		setFlee(
			Calc.FLEE(
				baseLevel,
				AGI,
				LUK,
				bonuses.bFlee ? bonuses.bFlee : 0,
				bonuses.bFleeRate ? bonuses.bFleeRate : 0,
			),
		)
	}, [baseLevel, AGI, LUK, bonuses /*bFlee, bFleeRate*/])
	useEffect(() => {
		setPerfectDodge(
			Calc.PerfectDodge(
				LUK,
				bonuses.bFlee2 ? bonuses.bFlee2 : 0,
				bonuses.bFlee2Rate ? bonuses.bFlee2Rate : 0,
			),
		)
	}, [LUK, bonuses /*bFlee2, bFlee2Rate*/])
	useEffect(() => {
		setCrit(
			Calc.CritRate(
				LUK,
				inventory['Right_Hand'].SubType === 'Bow'
					? (bonuses.bCritical ? bonuses.bCritical : 0) +
							(bonuses.bCriticalLong ? bonuses.bCriticalLong : 0)
					: bonuses.bCritical
						? bonuses.bCritical
						: 0,
				bonuses.bCriticalRate ? bonuses.bCriticalRate : 0,
			),
		)
	}, [inventory, LUK, bonuses /*bCritical, bCriticalLong, bCriticalRate*/])
	useEffect(() => {
		setASPD(
			Calc.ASPD(
				jobASPD,
				inventory['Right_Hand'],
				inventory['Left_Hand'],
				AGI,
				DEX,
				bonuses.bAspd ? bonuses.bAspd : 0,
				bonuses.bAspdRate ? bonuses.bAspdRate : 0,
			),
		)
	}, [jobASPD, inventory, AGI, DEX, bonuses /*bAspd, bAspdRate*/])

	// useEffect(() => {}, [])
	// useEffect(() => {}, [])
	// useEffect(() => {}, [])
	// useEffect(() => {}, [])

	return (
		<SubStatsContext.Provider
			value={{
				maxHP,
				maxSP,
				Def,
				softDef,
				Mdef,
				softMdef,
				hit,
				flee,
				perfectDodge,
				crit,
				aspd,
				statusATK,
				statusMATK,
				// statusBonus,
				// weaponATK,
				setBaseWeaponDamage,
				setBaseWeaponMagicDamage,
				// setWeaponLevel,
				setRefinementBonus,
				// setOverUpgradeBonus,
				// setSizePenalty,
				baseWeaponDamage,
				baseWeaponMagicDamage,
				refinementBonus,
				// baseDamage,
				baseMagicDamage,
			}}
		>
			{children}
		</SubStatsContext.Provider>
	)
}
